import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { HeaderContainer } from "./styles";
import { useAuth } from "../../../contexts/AuthContext";
import { useBroker } from "../../../contexts/BrokerContext";
import VelotaxLogo from "../../../assets/velotax/velotax-light.svg";
import VeloprimeLogo from "../../../assets/veloprime/logo-veloprime-horizontal-white.png";


export const Header = () => {
  const { user } = useAuth();
  const { currentBroker } = useBroker();

  const navigate = useNavigate();
  return (
    <HeaderContainer>
      <h1>
        <a
          href={currentBroker?.link || "https://www.veloprime.com.br/"}
          target="_blank"
          rel="noreferrer"
        >
          <img
            className="fixed"
            alt={"Velotax logo light"}
            src={VeloprimeLogo}
            style={{ height: "35px" }}
          />
        </a>
      </h1>
      {!user.user && (
        <div className="buttons">
          <Button size="medium" onClick={() => navigate("/p/login")}>
            <span style={{ color: "#FFFFFF", fontWeight: "bold", textDecoration: "none", borderBottom: "2px solid var(--ant-primary-color)" }}>Entrar</span>
          </Button>
          <span style={{ border: "1px solid #000" }}></span>
          {/* <Button
            size="medium"
            type="button"
            variant="contained"
            onClick={() => navigate("/p/cadastrar")}
          >
            Começar
          </Button> */}
        </div>
      )}
    </HeaderContainer>
  );
};
